export const TOGGLE_FILTER = 'TOGGLE_FILTER'
export const FETCH_TICKETS_REQUEST = 'FETCH_TICKETS_REQUEST'
export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS'
export const FETCH_TICKETS_FAILURE = 'FETCH_TICKETS_FAILURE'

export const FETCH_TICKETS_PARTIAL_SUCCESS = 'FETCH_TICKETS_PARTIAL_SUCCESS'

export const SET_SORT = 'SET_SORT'

export const SET_ACTIVE_TAB_SORTING = 'SET_ACTIVE_TAB_SORTING'

export const LOAD_MORE_TICKETS = 'LOAD_MORE_TICKETS'
